import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {translate} from "react-i18next";
import i18n from "i18next";
import {Container, Col, Row, Button} from "reactstrap";
import "../vodafone.css"
import iconTechnicianWhite from "../media/icons/technician-white.png"
import iconOnlineDevicesWhite from "../media/icons/online-devices-white.png"
import technicianAppointmentRequired from "../technicianRequired";

/**
 * @property mainButtonOnClick - Big red button onclick listener
 * @property mainButtonTextResource - Big red button text resource
 * @property backButtonOnClick - Back arrow button onclick listener. If this is set, the back button will be shown, otherwise it will be hidden
 * @property additionalText - If this is provided, the big red button will be slightly smaller and some extra text will be shown next to it
 */
class BottomBarActive extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        let technicianAppointmentRequired = true;
        if(this.props.technicianAppointmentRequired === false){
            technicianAppointmentRequired = false;
        }

        let button;
        if(this.props.technicianAppointmentRequired === false){
            button = ""; // Do not show
        }else if(this.props.shouldShowChangeAppointmentButton === true && this.props.buttonOnClick){
            button = <Button
                className={"button-white width-100"}
                style={{height:"48px"}}
                disabled={this.props.isAppointmentButtonDisabled}
                onClick={this.props.buttonOnClick}>
                    {i18n.t(this.props.buttonTextResource, this.props)}
            </Button>
        }else{
            button = <p  className={"text-bottom-bar-small-white"}>{i18n.t("cannot_be_changed")}</p>
        }


        let content;
        content=<Row>
            <Col xs={8}>
                <Row style={{height:"28px"}}>
                    <Col xs={2}>
                        <img src={iconTechnicianWhite} style={{height:"28px",width:"28px"}} />
                    </Col>
                    <Col xs={10} style={{paddingLeft:"6px"}}>
                        <p className={"text-bottom-bar-title"}>{i18n.t(this.props.mainText, this.props)}</p>
                    </Col>
                </Row>
                <Row style={{marginTop:"6px"}}>
                    <Col xs={12}>
                        <p className={"text-bottom-bar-subtitle"}>{i18n.t(this.props.subText, this.props)}</p>
                    </Col>
                </Row>
            </Col>
            <Col xs={4}>
                {button}
            </Col>

        </Row>;


        if(!technicianAppointmentRequired){
            content=<Row>
                <Col xs={3}>
                    <img src={iconOnlineDevicesWhite} style={{height:"58px",width:"58px"}} />
                </Col>
                <Col xs={9}>
                    <Row style={{height:"28px"}}>
                        <Col xs={12} style={{paddingLeft:"6px"}}>
                            <p className={"text-bottom-bar-title"}>{i18n.t(this.props.mainText, this.props)}</p>
                        </Col>
                    </Row>
                    <Row style={{marginTop:"6px"}}>
                        <Col xs={12} style={{paddingLeft:"6px"}}>
                            <p className={"text-bottom-bar-subtitle"}>{i18n.t(this.props.subText, this.props)}</p>
                        </Col>
                    </Row>
                </Col>


            </Row>;
        }



        return <Container className={"round-corners shadow bottom-bar bg-red-gradient"} style={{marginTop:"16px"}}>
            {content}
        </Container>
    }
}

export default translate("translations")(BottomBarActive);